import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder"]

import { ref, watch } from 'vue';
import { debounce } from 'lodash';
import { MagnifyingGlassIcon } from '@heroicons/vue/24/solid'


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
  placeholder: {
    type: String,
    default: 'Search...'
  },
  searchTerm: [Array, String],
},
  emits: ['update:search'],
  setup(__props, { emit: __emit }) {

const props = __props;

const localSearchTerm = ref(props.searchTerm);

const emit = __emit;

const debouncedSearch = debounce(() => {
  emit('update:search', localSearchTerm.value);
}, 300);

watch(() => props.searchTerm, (newValue) => {
  localSearchTerm.value = newValue;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'border-primary': localSearchTerm.value}, "flex items-center bg-white border border-solid border-gray-netural rounded-full text-sm h-8 px-3 min-w-[180px] relative focus-within:border-primary"])
  }, [
    _createVNode(_unref(MagnifyingGlassIcon), { class: "text-xs h-4 w-4 hidden xs:inline" }),
    _withDirectives(_createElementVNode("input", {
      type: "search",
      placeholder: __props.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localSearchTerm).value = $event)),
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(debouncedSearch) && _unref(debouncedSearch)(...args))),
      class: "border border-none cursor-pointer outline-none overflow-hidden pl-1 w-full"
    }, null, 40, _hoisted_1), [
      [_vModelText, localSearchTerm.value]
    ])
  ], 2))
}
}

})